import { render, staticRenderFns } from "./DocComentarios.vue?vue&type=template&id=b932ae92&scoped=true&lang=pug&"
import script from "./DocComentarios.vue?vue&type=script&lang=js&"
export * from "./DocComentarios.vue?vue&type=script&lang=js&"
import style0 from "./DocComentarios.vue?vue&type=style&index=0&id=b932ae92&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b932ae92",
  null
  
)

export default component.exports